import i18next from 'i18next';
import { clearCallTimeout } from '../../../core/functions/timeoutManager';

export const callCancelRequestReceivedByPlace = async (data, reducers, WSConnection) => {
  const { placeId, pointId, userId } = data;
  const { callDispatch, notificationDispatch } = reducers;

  await callDispatch({
    type: 'CALL_CANCEL',
    payload: {
      placeId,
      pointId,
      userId,
    },
  });

  const message = i18next.t('calls.NOTIFICATIONS.cancel');
  const date = new Date().getTime();
  const newNotification = new CustomEvent('Notification', {
    detail: { message, type: 'warning' },
  });
  clearCallTimeout('pending', userId);
  window.dispatchEvent(newNotification);

  notificationDispatch({
    type: 'UPDATE_NOTIFICATION',
    payload: {
      notificationId: 'call',
      message,
      placeId,
      pointId,
      type: 'warning',
      date,
    },
  });
};
